import { createContext } from 'react'

type PersonalizationContextType = {
  personalization: any
  license: any
  changePrimaryColor: (value: string) => void
}

const defaultValues = {
  personalization: {},
  license: {},
  changePrimaryColor: () => {},
}

const PersonalizationContext = createContext<PersonalizationContextType>(defaultValues)

export default PersonalizationContext
